/**
 * TKP-130 (karar 8) — envanter onay süreci açıkken toplu işlemler yalnız onay yetkilisine açık. Backend 403 döner
 * (`DraftGateService.assertApproverOnly`); arayüz bu giriş noktalarını açıklamayla gizler.
 */
const sid = (v) => String((v && v._id) || v || "");
/**
 * TKP-241 p.3: birimi "Onaysız Envanter Güncelleme" modundaysa (`status.directDepartments`) o birimde kilit yok — yazım doğrudan.
 * `department` verilmezse organizasyon geneli (eski davranış).
 */
export const directDepartment = (status, department) => !!(status && department && (status.directDepartments || []).map(String).includes(sid(department)));
export const bulkLocked = (status, department) => !!(status && status.enabled && !status.approver && !directDepartment(status, department));

/**
 * Kütüphaneden ekleme backend'de engellenen durumlar (birim kataloğu kapsam dışı). TKP-131: süreç×veri eklemesi
 * (`organizationProcessData`) listeden çıktı — taslağa düşer.
 */
// TKP-185 md.79: kütüphaneden süreç ekleme taslağa düşer (TKP-131'deki süreç×veri gibi) — kilit yalnız süreç×kaynak eklemesinde
export const LIBRARY_LOCKED_STATES = ["organizationProcessDatasource"];

export const libraryLocked = (status, organizationScopedState) => bulkLocked(status) && LIBRARY_LOCKED_STATES.includes(organizationScopedState);

const approvalStatus = (vm) => vm.$store && vm.$store.getters && vm.$store.getters["approval/status"];
/** Bileşenin birimi: `department` özelliği, sürecin birimi ya da Varlıklar'daki seçili birim (`parentEntity`). */
const scopeDepartmentOf = (vm) => vm.department || (vm.process && vm.process.department) || vm.parentEntity || null;

export default {
  computed: {
    bulkLocked() {
      return bulkLocked(approvalStatus(this), scopeDepartmentOf(this));
    },
    libraryLocked() {
      return libraryLocked(approvalStatus(this), this.organizationScopedState);
    },
  },
  created() {
    // Durum yalnız Varlıklar'da yükleniyordu; Envanter gibi ekranlar doğrudan açılabilir.
    if (this.$store && typeof this.$store.dispatch === "function" && !approvalStatus(this)) {
      const pending = this.$store.dispatch("approval/status");
      if (pending && typeof pending.catch === "function") pending.catch(() => undefined);
    }
  },
};
